<template>
  <StakeholderTable />
</template>

<script>
import StakeholderTable from "@/components/stakeholder/StakeholderTable";

export default {
  name: 'StakeHolderView',
  components: {StakeholderTable},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
